import { render } from "./reaction-group.vue?vue&type=template&id=8a6ceb66"
import script from "./reaction-group.vue?vue&type=script&lang=js"
export * from "./reaction-group.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__